module.exports = __webpack_public_path__ + "img/background-user-profile@2x.d7ecf6d4.jpg";